'use strict';

import {EvaluationBaseCtrl} from "./evaluationbasectrl.js";
import {evaluationAwrcriModel} from "../../models/evaluationawrcrimodel.js";

export class EvaluationAwrcriCtrl extends EvaluationBaseCtrl
{
	
	postConstruct(){
		this.cfg.esfaFieldPermission = this.jsDataService.get('cfgEsfaFieldPermission', false);
		let evaluation = this.jsDataService.get('evaluation', {});
		this.evaluation = new evaluationAwrcriModel(evaluation, this.$filter, this.jsDataService);
		if(typeof(evaluation.attachments) === 'object'){
			this.attachments = evaluation.attachments;
		}
//		this.showRequire = true;
	}
	
	getCriteria(){
//		return Object.values(this.evaluation.data_value.criteria);
		return this.evaluation.data_value.getCriteriaList();
	}
	
	autosavePostFields(){
		return {
			criteria: this.evaluation.data_value.getCriteriaData(),
			fields: this.evaluation.data_value.getFieldsData(),
			budgetReduction: this.evaluation.data_value.budgetReduction,
//			total: this.evaluation.data_value.total,
//			attachments: this.attachments
		};
	}
	
	confirmEvaluation(ev, form){
		const confirmTexts = this.jsDataService.get('evaluationConfirmTexts');
		const confirm = this.$mdDialog.confirm()
			.title(confirmTexts.title)
			.htmlContent(confirmTexts.content)
			.ariaLabel(confirmTexts.title)
			.targetEvent(ev)
			.ok(confirmTexts.ok)
			.cancel(confirmTexts.cancel);
		this.$mdDialog.show(confirm).then(() => {
			this.confirmEvaluationAction(ev, form);
		}, () => {});
	}
	
	confirmEvaluationAction(ev, form){
		this.showRequire = true;
		this.$timeout(()=>{
			let state = true;
			let notifyMessages = [];
			if(form.$invalid){
				let criteriaTab = false;
				let budgetTab = false;
				state = false;
//				console.log(form.$error);
				for(let key in form.$error){
					for(let field of form.$error[key]){
						if(criteriaTab && budgetTab){
							break;
						}
						let tab = this.detectTab(field)
						if(tab == 'criteria'){
							criteriaTab = true;
						}
						else if(tab == 'budget'){
							budgetTab = true;
						}
					}
				}
				if(criteriaTab){
					notifyMessages.push(this.$filter('tr')('err_check_required_fields_in_criteria'));
				}
				if(budgetTab){
					notifyMessages.push(this.$filter('tr')('err_check_required_fields_in_budget'));
				}
			}
			if(this.evaluation.data_value.budgetReduction.total.reduction > 0 && this.attachments.length < 1){
				notifyMessages.push(this.$filter('tr')('document_for_budget_reducion_required_in_attachments'));
				state = false;
			}
			
			if(this.evaluation.data_value.isAnyTooHigh()){
//			if(this.evaluation.data_value.isTooHigh()){
				notifyMessages.push(this.$filter('tr')('err_maximum_score_exceeded_in_criteria'));
				state = false;
			}
			
			if(state){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgConfirmUrl'),
					method: 'GET',
					params: {}
				});
			}
			else if (notifyMessages.length > 0){
				this.notify(notifyMessages, true);
			}
		});
		
	}
	
	detectTab(field){
		if(typeof(field.$$attr.tabName) !== 'undefined'){
			return field.$$attr.tabName;
		}
		return null;
	}
	
	fixPrecision(obj, field){
		if(!isNaN(obj[field]) && obj[field]){
			obj[field] = Number(obj[field].toFixed(2));
		}
	}
	
}
